import dayjs from "@/utils/time";

export const formatBytes = (bytes: number) => {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return "0 B";
  }
  const units = ["B", "KB", "MB", "GB", "TB"];
  let value = bytes;
  let index = 0;
  while (value >= 1024 && index < units.length - 1) {
    value /= 1024;
    index += 1;
  }
  return `${value >= 100 || index === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[index]}`;
};

export const formatSpeed = (bps: number) => `${formatBytes(bps)}/s`;

export const formatDuration = (seconds: number) => {
  const safeSeconds = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const secs = safeSeconds % 60;
  if (hours > 0) {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
  return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

export const formatCompletedTime = (timestamp?: number) => {
  if (!timestamp) {
    return "--";
  }
  return dayjs(timestamp).format("YYYY-MM-DD HH:mm");
};

/** 根据已有版本号列表计算下一个版本号，格式 X.Y.Z，Y/Z 最大为 9，X 无上限 */
export const calculateNextVersion = (versions: string[]): string => {
  if (!versions || versions.length === 0) return "0.0.1";

  let maxMajor = 0;
  let maxMinor = 0;
  let maxPatch = 0;

  for (const v of versions) {
    const parts = v.split(".");
    if (parts.length !== 3) continue;
    const major = parseInt(parts[0], 10);
    const minor = parseInt(parts[1], 10);
    const patch = parseInt(parts[2], 10);
    if (isNaN(major) || isNaN(minor) || isNaN(patch)) continue;

    if (
      major > maxMajor ||
      (major === maxMajor && minor > maxMinor) ||
      (major === maxMajor && minor === maxMinor && patch > maxPatch)
    ) {
      maxMajor = major;
      maxMinor = minor;
      maxPatch = patch;
    }
  }

  let newPatch = maxPatch + 1;
  let newMinor = maxMinor;
  let newMajor = maxMajor;

  if (newPatch > 9) {
    newPatch = 0;
    newMinor += 1;
  }
  if (newMinor > 9) {
    newMinor = 0;
    newMajor += 1;
  }

  return `${newMajor}.${newMinor}.${newPatch}`;
};

export const encodePassword = (password: string) => {
  const prefixRandom = Math.floor(Math.random() * 10000000)
    .toString(36)
    .substring(0, 3);
  const suffixRandom = Math.floor(Math.random() * 10000000)
    .toString(36)
    .substring(0, 4);
  const base64Password = Buffer.from(
    `${prefixRandom}${password}${suffixRandom}`,
  ).toString("base64");

  return `${prefixRandom}${base64Password}${suffixRandom}`;
};
